(() => {
  'use strict';
  function eligible(config, price, now, runtimeCurrency, market) {
    const start = Date.parse(config?.startsAt), end = Date.parse(config?.endsAt);
    if (config?.ready !== true || !config.discountId || config.percent !== 20 || config.endsAt !== '2026-10-28T11:00:00Z' || !Number.isFinite(start) || !Number.isFinite(end) || start >= end || !Number.isFinite(now) || now < start || now >= end) return false;
    if (String(config.collectionId) !== '361683157169' || String(price.collectionId) !== String(config.collectionId) || !Number.isSafeInteger(Number(price.productId)) || Number(price.productId) <= 0 || String(config.themeId) !== String(price.themeId)) return false;
    if (({NZ:'NZD', AU:'AUD'})[price.country] !== price.currency || runtimeCurrency !== price.currency) return false;
    if (!Number.isSafeInteger(Number(price.nativePrice)) || Number(price.nativePrice) <= 0 || price.nativeMarkdown !== 'false') return false;
    if (typeof market?.isCurrent !== 'function') return false;
    return market.isCurrent({country:price.country, currency:price.currency, themeId:price.themeId}) === true;
  }
  if (typeof module === 'object' && module.exports) module.exports = {eligible};
  if (typeof document === 'undefined' || window.ArohaReliefOfferDisplay) return;
  const reset = () => {
    document.querySelectorAll('[data-aa-relief-price]').forEach(node => {
      const native = node.querySelector('[data-relief-native]'), sale = node.querySelector('[data-relief-sale]');
      if (native) native.hidden = false;
      if (sale) sale.hidden = true;
    });
  };
  const update = () => {
    try {
      const config = JSON.parse(document.getElementById('ArohaReliefOfferConfig')?.textContent || 'null');
      document.querySelectorAll('[data-aa-relief-price]').forEach(node => {
        const native = node.querySelector('[data-relief-native]'), sale = node.querySelector('[data-relief-sale]');
        if (!native || !sale) {
          if (native) native.hidden = false;
          if (sale) sale.hidden = true;
          return;
        }
        const live = eligible(config, node.dataset, Date.now(), window.Shopify?.currency?.active, window.ArohaMarket);
        native.hidden = live;
        sale.hidden = !live;
      });
    } catch (_) { reset(); }
  };
  window.ArohaReliefOfferDisplay = {update, reset};
  update();
  setInterval(update, 1000);
  document.addEventListener('visibilitychange', update);
  document.addEventListener('shopify:section:load', update);
  window.addEventListener('pageshow', update);
  document.addEventListener('submit', event => {
    if (event.target?.action && new URL(event.target.action).pathname.endsWith('/localization')) reset();
  }, true);
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-aa-relief-price]') || node.querySelector('[data-aa-relief-price]'))))) update();
  }).observe(document.body, {childList:true, subtree:true});
})();
